<template>
  <b-modal
    id="xoa-nguoi-dung-group"
    centered
    size="md"
    hide-footer
    header-class="border-bottom-none"
    footer-class="border-top-none"
    :title="title"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <div class="font-size-14">
      <div class="d-flex justify-content-end">
        <base-button
          button="Xóa"
          class="btn btn-main ml-2"
          @click="xoaNguoiDung()"
          :disabled="isLoading"
        >
          ĐỒNG Ý
        </base-button>
        <base-button
          button="Hủy"
          class="btn btn-yellow"
          @click="hideModal()"
          :disabled="isLoading"
        >
          {{ BO_QUA_BUTTON_LABEL }}
        </base-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { ROUTE_NAME, BO_QUA_BUTTON_LABEL } from "@/constants/constants";

export default {
  name: "XoaNguoiDungGroupModal",
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      ROUTE_NAME: ROUTE_NAME,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("xoa-nguoi-dung-group");
    },
    xoaNguoiDung() {
      this.$emit("xoaNguoiDung");
    },
  },
};
</script>
<style lang="scss">
#xoa-nguoi-dung-group .modal-header {
  background: white;
  h5 {
    color: black;
  }

  .close {
    display: none;
  }
}
</style>
